<script setup>
import { ref } from 'vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Head } from '@inertiajs/inertia-vue3';
import UnensNavLink from '@/Components/NavLink.vue';
import CardBox from "@/Components/CardBox.vue";
import CardBoxComponentForbidden from '@/Components/CardBoxComponentForbidden.vue';
import BaseIcon from "@/Components/BaseIcon.vue";
import PageHeader from '@/Components/PageHeader.vue';

import {
    mdiEye, mdiTrashCan, mdiPencil, mdiCheckCircle, mdiCloseCircle, mdiBook, mdiSchool, mdiBookOpenVariant, mdiAndroidStudio, mdiAccountGroup, mdiAccountTie, mdiApps, mdiLifebuoy, mdiAbTesting, mdiCog,
    mdiDna, mdiPen
} from "@mdi/js";
import { Icon } from "@iconify/vue";
import Buttons from '@/Components/Buttons.vue';

// Configuración de ejemplo para las pestañas
const currentTab = ref(1);
const tabOptions = [
    { id: 1, label: 'General', icon: 'tabler:apps' },
    { id: 2, label: 'Logos', icon: 'tabler:photo' },
    { id: 3, label: 'Documentos', icon: 'tabler:file-text' },
    { id: 4, label: 'Documentos', icon: 'tabler:file-text' },
    { id: 5, label: 'Documentos', icon: 'tabler:file-text' },
    { id: 6, label: 'Documentos', icon: 'tabler:file-text' },
];
</script>

<template>

    <!-- <template #header>
            <PageHeader title="Configuración" subtitle="Módulo de configuración" :back-route="null" :tabs="tabOptions" :show-back="false" v-model="currentTab" :actions-on-bottom-on-mobile="false" :actionsInTabsOnMobile="true" :wrapTabsOnMobile="false">
                <template #actions>
                    <Buttons href="/" color="primary" size="header" icon="mdi:arrow-u-left-top-bold" label="Volver al Inicio" :hideLabelOnMobile="true" />
                </template>
            </PageHeader>
        </template> -->

    <Head title="Configuración" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PageHeader title="Configuración" subtitle="Panel de administración" :back-route="null" :show-back="false" v-model="currentTab">
                <template #actions>
                    <Buttons :href="route('dashboard')" color="primary" size="header" icon="mdi:arrow-u-left-top-bold" label="Volver al Inicio" :hideLabelOnMobile="true" />
                </template>
            </PageHeader>
        </template>

        <!--<div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        Hola Configuración de cursos
                        
                    </div>
                </div>
            </div>
        </div>-->

        <div class="py-8 lg:py-10">
            <!-- LRR hover:grid-cols-6 el sm funciona en los grandes parece que stá al reves setudiar eso-->
            <!--<div class="max-w-7xl mx-auto sm:px-6 lg:px-8 grid grid-cols-2 gap-4 sm:grid sm:grid-cols-4">-->
            <template v-if="$page.props.auth.user.id_rol <= 6">
                <div class="mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-5">
                    <!-- General -->
                    <div v-if="$page.props.auth.user.id_rol <= 5" class="w-full border rounded-md hover:shadow-2xl transition-shadow duration-500 shadow-lg md:mx-auto">
                        <div class="flex flex-col">
                            <div class="bg-rose-600 border-rose-600 text-white rounded-t-md flex items-center p-6 transition-colors">
                                <BaseIcon :path="mdiApps" :size="24" class="mr-3 text-white w-6 h-6" />
                                <div>
                                    General
                                </div>
                            </div>
                            <div class="mb-6 p-6"><!-- card-body, pl-100 pue sya tiene estilos las listas -->
                                <ul class="list-disc text-rose-600">


                                    <!-- <li><UnensNavLink  class="hover:text-rose-600" href="#">Constantes</UnensNavLink></li> -->
                                    <!-- <li><UnensNavLink  class="hover:text-rose-600" :href="route('file-listado', {'type': 'file_forlevel'})">Documentos iniciales</UnensNavLink></li> -->
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('collaborator-list')">Colaboradores</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('constante-edit')">Opciones avanzadas</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('config-mark')">Mis Marcadores</UnensNavLink>
                                    </li>
                                    <!-- <li><UnensNavLink  class="hover:text-rose-600" href="#">Configurar Zoom (Reunión Virtual)</UnensNavLink></li> -->
                                </ul>
                            </div>
                        </div>

                    </div>

                    <!-- Admincoor hacia arriba -->
                    <div v-if="$page.props.auth.user.id_rol <= 4 || $page.props.auth.user.id_rol == 6" class="w-full border rounded-md hover:shadow-2xl transition-shadow duration-500 shadow-lg md:mx-auto">
                        <div class="flex flex-col">
                            <div class="bg-rose-600 border-rose-600 text-white rounded-t-md flex items-center p-6 transition-colors">
                                <BaseIcon :path="mdiLifebuoy" :size="24" class="mr-3 text-white w-6 h-6" />
                                <div>
                                    Mantenimiento
                                </div>
                            </div>
                            <div class="mb-6 p-6">
                                <ul class="list-disc text-rose-600">
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('config-estadocivil')">Estados civiles</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('config-complaintbook')">Libro de Reclamaciones</UnensNavLink>
                                    </li>
                                    <!-- <li><UnensNavLink  class="hover:text-rose-600" href="#">AFPs</UnensNavLink></li> -->


                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Admincoord hacia arriba -->
                    <div v-if="$page.props.auth.user.id_rol <= 4" class="w-full border rounded-md hover:shadow-2xl transition-shadow duration-500 shadow-lg md:mx-auto">
                        <div class="flex flex-col">
                            <div class="bg-rose-600 border-rose-600 text-white rounded-t-md flex items-center p-6 transition-colors">
                                <BaseIcon :path="mdiAccountTie" :size="24" class="mr-3 text-white w-6 h-6" />
                                <div>
                                    RRHH
                                </div>
                            </div>
                            <div class="mb-6 p-6">
                                <ul class="list-disc text-rose-600">
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('freeday-list')">Días Libres</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('config-puestolaboral')">Puestos Laborales</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('config-typedoc')">Tipos de documento</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('config-relojasistencia')">Reloj de Asistencia</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('config-collaboratorturn')">Turnos de asistencia</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('config-collaboratorhour')">Horarios de Asistencia</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('config-holiday')">Días Festivos</UnensNavLink>
                                    </li>
                                    <!-- <li><UnensNavLink  class="hover:text-rose-600" href="#">AFPs</UnensNavLink></li> -->
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Info Admin -->
                    <div v-if="$page.props.auth.user.id_rol == 1" class="w-full border rounded-md hover:shadow-2xl transition-shadow duration-500 shadow-lg md:mx-auto">
                        <div class="flex flex-col">
                            <div class="bg-rose-600 border-rose-600 text-white rounded-t-md flex items-center p-6 transition-colors">
                                <BaseIcon :path="mdiCog" :size="24" class="mr-3 text-white w-6 h-6" />
                                <div>
                                    Avanzado
                                </div>
                            </div>
                            <div class="mb-6 p-6">
                                <ul class="list-disc text-rose-600">
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('config-company')">Configurar Compañía</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('user-listado')">Usuarios</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('config-constante')">Constantes</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('config-importarexcel')">Importar excel</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" href="#">Roles de usuarios</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('config-distrito')">Distritos</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('config-help')">Ayuda</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('config-lang')">Traductor</UnensNavLink>
                                    </li>
                                    <li>
                                        <UnensNavLink class="hover:text-rose-600" :href="route('system-info')">Info</UnensNavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="container mx-auto sm:px-6 lg:px-8">
                    <CardBox>
                        <CardBoxComponentForbidden />
                    </CardBox>
                </div>

            </template>


        </div>
    </BreezeAuthenticatedLayout>
</template>